<template>
  <div id="Home">
    <header id="header">
      <div class="container">
        <router-link to="/" class="logo">
          <img src="@/assets/img/logo.png" alt="" />
        </router-link>
        <nav id="headerNav">
          <!-- <div class="link-box">
            <router-link to="/">
              <span class="link">{{ $t("Travel") }}</span>
            </router-link>
          </div> -->
          <div class="link-box">
            <router-link to="/">
              <span class="link">{{ $t("Casino") }}</span>
            </router-link>
          </div>
          <div class="link-box">
            <router-link to="/Introduction/8">
              <span class="link">{{ $t("Lottery") }}</span>
            </router-link>
          </div>
          <div class="link-box">
            <router-link to="/Introduction/9">
              <span class="link">{{ $t("Game") }}</span>
            </router-link>
          </div>
        </nav>
        <div class="language">
          <span>◆</span>
          <span @click="$i18n.locale = 'es'">FRANCAIS</span>
          <span @click="$i18n.locale = 'en'">ENGLISH</span>
          <span @click="$i18n.locale = 'zh-cn'">简体中文</span>
        </div>
      </div>
    </header>
    <main id="main">
      <router-view />
    </main>
    <footer id="footer">
      <div class="border">
        <img src="@/assets/img/footer-border.png" alt="" />
      </div>
      <div class="content">
        <span>{{ $t("Introduction1") }}</span>
        <span>{{ $t("Introduction2") }}</span>
        <span>{{ $t("Introduction3") }}</span>
      </div>
      <div class="logo">
        <img src="@/assets/img/logo.png" alt="" />
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {};
  },
};
</script>
<style lang="scss">
@import "assets/sass/globle.scss";
#Home {
  margin: auto;
  max-width: 1140px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  #header {
    background-color: #3a685a;
    width: 100%;
    height: 100%;
    .container {
      display: flex;
      align-items: center;
      position: relative;
      .logo {
        position: relative;
        z-index: 99;
        padding: 16px 42px;
        width: 90px;
      }
      #headerNav {
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        a {
          font-size: 28px;
          font-weight: 600;
          color: #bfbc62;
          padding: 8px 20px;
          letter-spacing: 6px;
          &:active {
            border-top-left-radius: 30px;
            border-bottom-left-radius: 30px;
            color: #fde453;
            background: rgb(0, 0, 0);
            background: linear-gradient(
              90deg,
              rgba(0, 0, 0, 0.8) 0%,
              rgba(255, 255, 255, 1) 100%
            );
          }
        }
        .link-box {
          border-right: 2px solid #d0e7dc;
          border-left: 2px solid #d0e7dc;
          margin: 4px;
          padding: 8px;
          &:first-child {
            border-left: none;
          }
          &:last-child {
            border-right: none;
          }
          .link {
            &:hover {
              color: #fde453;
              padding: 0 0 4px;
              border-bottom: #fde453 2px solid;
            }
          }
        }
      }
      .language {
        position: absolute;
        right: 16px;
        top: 16px;
        span {
          color: #b3b2b0;
          padding: 5px;
          font-size: 16px;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
  #main {
    width: 100%;
    display: flex;
    justify-content: center;
    .home {
      .bannerBtmLine {
        display: flex;
        justify-content: space-around;
        padding: 15px 0;
        .leftLine,
        .rightLine {
          width: 48%;
          height: 20px;
        }
        .leftLine {
          background-color: rgb(0, 104, 71);
        }
        .rightLine {
          background-color: rgb(206, 17, 38);
        }
      }
      .mainTop {
        display: flex;
        justify-content: space-between;
        .Breadcrumb {
          font-size: 20px;
          font-weight: 600;
          color: #d7af21;
          align-self: center;
        }
        @media screen and (max-width: 1140px) {
          .Breadcrumb {
            padding-left: 8px;
            font-size: 16px;
          }
          .topLine {
            margin: 0 12px;
          }
        }
        .topLine {
          align-self: flex-end;
          margin: 0 24px;
          width: 78%;
          height: 3px;
          background-color: #b6b640;
        }
      }
    }
  }
  #footer {
    background-color: #3a685a;
    position: relative;
    .border {
      padding: 8px;
    }
    .content {
      box-sizing: border-box;
      position: absolute;
      left: 0;
      top: 0;
      padding: 75px 150px 0 150px;
      span {
        padding: 0.3rem 0;
        font-size: 20px;
        letter-spacing: 1px;
        line-height: 30px;
        color: #fdede4;
        display: block;
      }
    }
    .logo {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 5px;
      max-width: 95px;
    }
  }
}
</style>
